const initialSettings = {};

export default (state = initialSettings, action) => {
  switch (action.type) {
    case "UPLOAD_SUCCESS": {
      return { ...state, ids: action.payload };
    }

    default:
      return state;
  }
};
